/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Val3_TitleInputs */

const en_dr_room_val3_title = /** @type {(inputs: Dr_Room_Val3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every feature carries its origin`)
};

const id_dr_room_val3_title = /** @type {(inputs: Dr_Room_Val3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiap fitur punya asal-usul`)
};

/**
* | output |
* | --- |
* | "Every feature carries its origin" |
*
* @param {Dr_Room_Val3_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_val3_title = /** @type {((inputs?: Dr_Room_Val3_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Val3_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_val3_title(inputs)
	return en_dr_room_val3_title(inputs)
});